import { NgModule } from "@angular/core";

import { AccessSelectorComponent } from "./access-selector.component";

@NgModule({
  imports: [AccessSelectorComponent],
  exports: [AccessSelectorComponent],
})
export class AccessSelectorModule {}
